module.exports = "<div class=\"nav-menu\">\n  <li ng-repeat=\"menu in myMenus\"\n    ng-show=\"menu.display()\"\n    ng-class=\"{active: menu.isActive}\">\n    <a class=\"black-text\"\n      ng-click=\"menu.go()\">\n      <i class=\"{{$root.styles.icons.left}}\"\n        ng-bind-html=\"menu.icon\"></i>\n      <span ng-bind-html=\"menu.title\"></span>\n    </a>\n  </li>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/global/directives/menus/myHomeMenu.html
// module id = 1233
// module chunks = 0